import { ReactElement } from 'react';
import styled from 'styled-components';

import { MedicalDataAccessAuthorization } from '@dreryk/egabinet-patient-frontend-api';

import { ValueRendererProps } from '@dreryk/react-components';

import { ModifyMedicalDataAccessAuthorizationAction } from '../../ModifyMedicalDataAccessAuthorizationAction/ModifyMedicalDataAccessAuthorizationAction';
import { WithdrawMedicalDataAccessAuthorizationAction } from '../../WithdrawMedicalDataAccessAuthorizationAction/WithdrawMedicalDataAccessAuthorizationAction';

const StyledActions = styled.div`
   display: inline-flex;
`;

const ActionsCell = (props: ValueRendererProps<MedicalDataAccessAuthorization, number>): ReactElement | null => {
   return (
      <StyledActions>
         <ModifyMedicalDataAccessAuthorizationAction data={props.bean} />
         <WithdrawMedicalDataAccessAuthorizationAction
            id={props.bean.id}
            firstName={props.bean.firstName}
            lastName={props.bean.lastName}
         />
      </StyledActions>
   );
};

export { ActionsCell };
